import React from 'react';

import Banner, { Variants as BannerVariants } from './index';

export type AppProps = {
  message?: string;
  className?: string;
  canClose?: boolean;
  testId?: string | null;
};

const WarningBanner: React.FC<AppProps> = ({
  message = null,
  className = '',
  canClose = false,
  testId = null,
}) => {
  if (!message) {
    return null;
  }

  return (
    <div className={className} data-testid={testId}>
      <Banner
        title={message}
        leftIcon="exclamation"
        variant={BannerVariants.Warning}
        className="mb-4"
        canClose={canClose}
      />
    </div>
  );
};

export default WarningBanner;
